import React from 'react';
import { toastStore } from '../../../../stores/program-reserve/toast-store.js';
import { ToastStoreContext } from '../../context/ToastStoreContext.js';

const ToastStoreProvider = ({ children }) => {
  return <ToastStoreContext.Provider value={toastStore}>{children}</ToastStoreContext.Provider>;
};

export default ToastStoreProvider;
